import { Schemas } from '@api-client/generated/types';

type Membership = Schemas.AdminMembershipRecordDto;
type AdminRole = NonNullable<Schemas.User['adminRole']>;

const ROLE_LABELS: Record<AdminRole, string> = {
  admin: 'Admin',
  accountant: 'Accountant',
  kyc: 'KYC',
  support: 'Support',
};

export const CLIENT_MEMBER_LABEL = 'Client user';

/** Human-readable role tag: a backoffice role, or "Client user" for members
 * without one (the client's own portal users). */
export const roleLabel = (adminRole: Membership['adminRole']): string =>
  adminRole ? ROLE_LABELS[adminRole] : CLIENT_MEMBER_LABEL;

export const fullName = (member: Pick<Membership, 'firstName' | 'lastName'>) =>
  `${member.firstName} ${member.lastName}`.trim();

export const initials = (
  member: Pick<Membership, 'firstName' | 'lastName' | 'email'>
): string => {
  const first = member.firstName?.trim()?.[0];
  const last = member.lastName?.trim()?.[0];
  const combined = `${first ?? ''}${last ?? ''}`;
  return combined || member.email?.trim()?.[0] || '?';
};
